//Scroll To Hash on different page
var jump = function(e) {
	if (e) {
		e.preventDefault();
		var target = $(this).attr("href");
	} else {
		var target = location.hash;
	}

	$('html,body').animate({
		scrollTop: $(target).offset().top
	}, 2000, function() {
		location.hash = target;
	});

}

//$('html, body').hide();
if (location.hash) {
	//console.log("HASH TO: ", location.hash);
	/*$(function(){
		$(window).scrollTop(0);
	});
	setTimeout(function() {
		$('html, body').scrollTop(0).show();
		jump();
	}, 1000);*/
}
$(document).ready(function() {
	//console.log("header.js | Ready")

});